// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__2hdUL","title":"tooltip_title__2V-7L","text":"tooltip_text__Lutzx","arrow":"tooltip_arrow__16M03"};